import { FC, lazy, useMemo } from 'react';
import { useToggle } from '@csp/csp-web-hooks';
import { IconButton } from '@csp/csp-web-ui';
import { BarcodeInputDialog } from '../component/BarcodeInputDialog';
import { KitDetailsDrawer } from '../../hbs/hbs-kit-details/container/KitDetailsDrawer';
import { BarcodeType } from '../../../common/model/BarcodeType';
import { useContainerSync } from '../../hbs/hook/useContainerSync';
import { useVisitRequests } from '../../patient-list/patient-list-visit/hook/useVisitRequests';
import { StaticContentService } from '../../../common/service/StaticContentService';
import { useBioSampleDetailsToggle } from '../hook/useBioSampleDetailsToggle';

const BioSampleDetailsDrawer = lazy(
  () => import(/* webpackPrefetch: true */ '../../hbs/hbs-details/container/BioSampleDetailsDrawer'),
);

export const BarcodeInputContainer: FC = () => {
  const toggle = useToggle(false);
  const { isContainerSyncEnabled } = useContainerSync();
  const { hbsEnabled } = useVisitRequests();
  const texts = StaticContentService.getGenericEntry('webHcpBarcodeInput');

  const bioSampleDetailsToggle = useBioSampleDetailsToggle();

  const enabledBarcodeTypes: BarcodeType[] = useMemo(() => {
    const types: BarcodeType[] = [];
    if (isContainerSyncEnabled) {
      types.push(BarcodeType.HBS_KIT_CODE);
    }
    if (hbsEnabled) {
      types.push(BarcodeType.HBS_SAMPLE_CODE);
    }
    return types;
  }, [isContainerSyncEnabled, hbsEnabled]);

  return enabledBarcodeTypes.length > 0 ? (
    <>
      <KitDetailsDrawer />

      {bioSampleDetailsToggle.isMounted && <BioSampleDetailsDrawer toggle={bioSampleDetailsToggle} />}

      <BarcodeInputDialog toggle={toggle} enabledBarcodeTypes={enabledBarcodeTypes} />

      <IconButton
        tooltip={{
          title: texts.appBar.button.scan.tooltip,
        }}
        iconProps={{ name: 'barcode', size: 'large', color: 'black' }}
        onClick={toggle.setOn}
        my={{ xs: 0, sm: 1, lg: 1.25 }}
        mx="1rem"
      />
    </>
  ) : null;
};
